<template>
  <div>
    <div class="alert_popup">
      <div class="popup_con">
        <div class="txt_container">
          <div class="txt_icon">
            <img src="@/assets/images/settings/reset.svg" />
          </div>
          <div class="txt_title">앱 업데이트가 필요해요</div>
          <div class="txt_content">{{ appUpdateMessage }}</div>
        </div>
        <button type="button" class="btn_fill" @click="fnUpdateApp">
          지금 업데이트하기
        </button>
        <button
          type="button"
          class="btn_faint"
          style="margin-top: 12px"
          @click="fnUpdateLater"
        >
          다음에 할래요
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";

require("@/assets/css/popup.css");

export default {
  name: "AppUpdateModalComponent",
  data() {
    return {};
  },
  computed: {
    ...mapState(["_state", "_modal"]),
    ...mapState("userStore", ["_deviceInfo"]),
    ...mapState("settingsStore", ["_app_update"]),
    hasDevicePushToken() {
      return this._deviceInfo?.push_token?.length > 0;
    },
    hasAppVersion() {
      return this._deviceInfo?.app_version?.length > 0;
    },
    appUpdateMessage() {
      return this._app_update.userMsg || "";
    },
    appUpdateVersion() {
      return this._app_update.appVersion || null;
    },
    appStoreUrl() {
      const platform = this._deviceInfo?.platform;
      if (platform === "ios") {
        return "https://apps.apple.com/kr/app/%EB%82%B4%EC%A7%91%EC%8A%A4%EC%BA%94/id1671547897";
      } else if (platform === "android") {
        return "https://play.google.com/store/apps/details?id=com.kredatalab.naezipscan_app";
      }
      return null;
    },
  },
  methods: {
    ...mapActions("settingsStore", ["acRejectAppUpdate"]),
    ...mapMutations("settingsStore", ["setAppUpdateModal"]),
    fnUpdateApp() {
      this.$mixpanel_track("Click Operation-Update Accept");
      if (this.appStoreUrl) {
        window.open(this.appStoreUrl, "_blank");
      }
    },
    async fnUpdateLater() {
      this.$mixpanel_track("Click Operation-Update Deny");
      if (
        this.hasDevicePushToken &&
        this.hasAppVersion &&
        this.appUpdateVersion
      ) {
        await this.acRejectAppUpdate({
          target_app_version: this.appUpdateVersion,
          app_version: this._deviceInfo.app_version,
          device_push_token: this._deviceInfo.push_token,
        });
      }
      this.setAppUpdateModal(false);
    },
  },
};
</script>
<style scoped>
.alert_popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;
}
.popup_con {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 462px;
  min-height: 224px;
  border-radius: 20px;
  background-color: #fff;
  padding: 20px;
  max-height: 80%;
}
.txt_container {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.txt_icon {
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
}
.txt_title {
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  color: var(--Grayscale-Black, #121212);
  white-space: pre-line;
  margin-bottom: 8px;
}
.txt_content {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--Grayscale-Black, #121212);
  white-space: pre-line;
}

.btn_fill {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  min-height: 45px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 10px;
  background-color: #5087ff;
  color: #fff;
}
.btn_faint {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 18px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 18px;
  background-color: #fff;
  color: var(--Grayscale-Gray, #979797);
  text-decoration: underline;
}

@media screen and (max-width: 1080px) {
  .alert_popup .popup_con {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 322px;
    border-radius: 20px;
    background-color: #fff;
  }
  .alert_popup .popup_con_title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 322px;
    border-radius: 20px;
    background-color: #fff;
  }
}
</style>
